export default "__VITE_ASSET__DOFuA7wP__"